/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchRequestDto } from './SearchRequestDto';
import {
    SearchRequestDtoFromJSON,
    SearchRequestDtoFromJSONTyped,
    SearchRequestDtoToJSON,
    SearchRequestDtoToJSONTyped,
} from './SearchRequestDto';
import type { FilterRequestDto } from './FilterRequestDto';
import {
    FilterRequestDtoFromJSON,
    FilterRequestDtoFromJSONTyped,
    FilterRequestDtoToJSON,
    FilterRequestDtoToJSONTyped,
} from './FilterRequestDto';
import type { CategoryTreeNodeExtendedDtoSortingRequestDto } from './CategoryTreeNodeExtendedDtoSortingRequestDto';
import {
    CategoryTreeNodeExtendedDtoSortingRequestDtoFromJSON,
    CategoryTreeNodeExtendedDtoSortingRequestDtoFromJSONTyped,
    CategoryTreeNodeExtendedDtoSortingRequestDtoToJSON,
    CategoryTreeNodeExtendedDtoSortingRequestDtoToJSONTyped,
} from './CategoryTreeNodeExtendedDtoSortingRequestDto';
import type { PagingRequestDto } from './PagingRequestDto';
import {
    PagingRequestDtoFromJSON,
    PagingRequestDtoFromJSONTyped,
    PagingRequestDtoToJSON,
    PagingRequestDtoToJSONTyped,
} from './PagingRequestDto';

/**
 * 
 * @export
 * @interface CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
 */
export interface CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    /**
     * 
     * @type {FilterRequestDto}
     * @memberof CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
     */
    filters?: FilterRequestDto;
    /**
     * 
     * @type {SearchRequestDto}
     * @memberof CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
     */
    search?: SearchRequestDto;
    /**
     * 
     * @type {PagingRequestDto}
     * @memberof CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
     */
    paging?: PagingRequestDto;
    /**
     * 
     * @type {CategoryTreeNodeExtendedDtoSortingRequestDto}
     * @memberof CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto
     */
    sorting?: CategoryTreeNodeExtendedDtoSortingRequestDto;
}

/**
 * Check if a given object implements the CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto interface.
 */
export function instanceOfCategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto(value: object): value is CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    return true;
}

export function CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoFromJSON(json: any): CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    return CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json, false);
}

export function CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filters': json['filters'] == null ? undefined : FilterRequestDtoFromJSON(json['filters']),
        'search': json['search'] == null ? undefined : SearchRequestDtoFromJSON(json['search']),
        'paging': json['paging'] == null ? undefined : PagingRequestDtoFromJSON(json['paging']),
        'sorting': json['sorting'] == null ? undefined : CategoryTreeNodeExtendedDtoSortingRequestDtoFromJSON(json['sorting']),
    };
}

export function CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSON(json: any): CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto {
    return CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSONTyped(json, false);
}

export function CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSONTyped(value?: CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filters': FilterRequestDtoToJSON(value['filters']),
        'search': SearchRequestDtoToJSON(value['search']),
        'paging': PagingRequestDtoToJSON(value['paging']),
        'sorting': CategoryTreeNodeExtendedDtoSortingRequestDtoToJSON(value['sorting']),
    };
}

